import React from 'react';
import './reconStatus.css';
import { REGENERATION_INVOICE_USE_CASE_ID } from '../../UserConfig/UserRequest/userRequestPiTiValidation';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const getReconStatusClass = (status) => {
  const normalized = String(status || '').trim().toLowerCase();
  if (normalized === 'pending') return 'helpdesk-recon-status--pending';
  if (normalized === 'success') return 'helpdesk-recon-status--success';
  if (normalized === 'failed') return 'helpdesk-recon-status--failed';
  return null;
};

export const formatReconStatus = (reconStatus, row) => {
  if (parseInt(row?.use_case_id, 10) !== REGENERATION_INVOICE_USE_CASE_ID) {
    return '';
  }

  const display = cell(reconStatus);
  const statusClass = getReconStatusClass(display);
  if (!statusClass) return display;

  return <span className={`helpdesk-recon-status ${statusClass}`}>{display}</span>;
};
